import { Navigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

function ProtectedRoute({ children }) {
  const [user, setUser] = useState(undefined); // ⚠️ undefined, um initialen Ladezustand zu erkennen
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (newUser) => {
      setUser(newUser);
    });
    return () => unsubscribe();
  }, []);

  // Noch nicht geladen (optional: Ladeanimation möglich)
  if (user === undefined) return null;

  // Nicht eingeloggt? Dann umleiten, aber die ursprünglich angeforderte URL
  // (z. B. ein geteilter /event/:eventId-Link) merken, damit Auth.js nach dem
  // Login/Registrieren dorthin zurückleiten kann.
  if (!user) return <Navigate to="/auth" replace state={{ from: location }} />;

  return children;
}

export default ProtectedRoute;